import script from "./Deposit.vue?vue&type=script&setup=true&lang=js"
export * from "./Deposit.vue?vue&type=script&setup=true&lang=js"

import "./Deposit.vue?vue&type=style&index=0&id=f5ceaefc&lang=less&scoped=true"
import "./Deposit.vue?vue&type=style&index=1&id=f5ceaefc&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5ceaefc"]])

export default __exports__